module.exports = JSON.parse('{"Tracked series":"{{trackedSeries}} Отслеживаемые серии"}')